<template>
    <div class="app-container">
        <div class="filter-container">
      
        </div>
        <!--
         <div class="filter-container">
                    <el-button type="success"  @click="handleSave" icon="el-icon-plus" size="mini" plain>{{$t('commons.batchsave')}}</el-button>
          </div>
       -->
        <el-table
              
                :data="list"
                element-loading-text="Loading"
                border
                fit
                highlight-current-row
                stripe @selection-change="handleSelectionChange">
         <el-table-column
                            prop="deviceId"
                            v-if="false"
                            fixed type="selection" align="center" width="50">
                    </el-table-column>
           <el-table-column prop="userName" :label="$t('input.performanc.num')" align="center">
            </el-table-column>
             <el-table-column prop="userName" :label="$t('input.performanc.name')" align="center">
            </el-table-column>
            <el-table-column :label="$t('input.performanc.value')" align="center">
              <template slot-scope="scope">
                    <template v-if="scope.row.edit">
                        <el-input v-model="scope.row.tagName" maxlength="80" :show-word-limit="true" size="small" clearable :placeholder="$t('commons.pleaseInput')"/>
                    </template>
                    <span v-else>{{ scope.row.tagName }}</span>
                </template>
            </el-table-column>
           <el-table-column prop="operation" :label="$t('commons.actions')" align="center">
                <template slot-scope="scope">
                    <template v-if="scope.row.edit">
                        <div class="iori-buttons">
                            <a class="iori-button" @click="updateTag(scope.row)" :title="$t('commons.save')"><i class="el-icon-circle-check"></i></a>
                            <a class="iori-button"  @click="cancelTagEdit(scope.row)" :title="$t('commons.cancel')"><i class="el-icon-circle-close"></i></a>
                        </div>
                    </template>
                    <template v-else>
                        <div class="iori-buttons">
                            <a class="iori-button" @click="editTag(scope.row)" :title="$t('commons.edit')"><i class="el-icon-edit-outline"></i></a>
                           
                        </div>
                    </template>
                </template>
            </el-table-column>
           
        </el-table>
        <pagination v-show="total>0" :total="total" :page.sync="listQuery.current" :limit.sync="listQuery.rowCount"
                    @pagination="getTagPage"/>

       
    </div>
</template>

<script>
  import {
        getTagList,
        getTagTypeList
    
    } from '@/api/iori/tag'
    import{
        getProjectList
    }from '@/api/business/base/tenant/project'
    import {      
        getPositionTree
    } from '@/api/business/base/tenant/device'
    import Pagination from '@/components/Pagination'
  
    import { envInfo } from '@/constants/envInfo'
    import store from '@/store/index'
    import {listToTree} from '@/utils/tree'
    import TreeSelect from '@riophae/vue-treeselect';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    export default {
        name: 'TagManager',
        components: {Pagination, TreeSelect},
        data() {
           return{
               addDialog: false,
               createLoading: false,
               tagTypeList:[],
               list: null,
               total: 0,
               listLoading: true,
               projectList:[],
               positionList:[],
               rootPath: envInfo.bgApp.tagPath,
               multipleSelection:[],
               listQuery: {
                   current: 1,
                   rowCount: 10,
                   selectMonth: null,
                   positionId : null,
                   projectId: null,
               },
               // 日期范围查询组件
               pickerOpts: {
                   // 默认日期
                   pickerData: null,
                   // 快捷选项
                   shortcuts: null,
               },
               form:{
                   selectMonth: null,
                   positionId : null,
                   projectId: null,
                   rowid: null,
             
               },
             
           }
        },
        created() {
            this.getTagPage();
            this.getTagTypeList();
            this.getProjectList();
        },
        methods: {
              selectPosition(node){
                this.listQuery.positionId = node.positionId;
                //alert(this.listQuery.positionId);
               },
                
           
            getProjectList(companyId){
                getProjectList({"companyId":companyId}).then(res=>{
                    this.projectList = res;
                })
            },
           changeProject() {
                if(this.listQuery.projectId == ''){
                    this.listQuery.projectId = null;
                    this.listQuery.positionId = null;
                    this.positionList = [];
                }else{                   
                   getPositionTree({"projectId":this.listQuery.projectId}).then(response =>{
                     
                        //alert(this.listQuery.projectId);
                        this.listQuery.positionId = null;
                        this.positionList = [];
                        let data = listToTree(response,"positionId","parentId");
                        this.recursivePosition(data)
                    });
                }
            },
            //递归位置列表修改属性及数据结构
            recursivePosition(row){
                let data = row.map(v => {
                    v.label = v.positionName;
                    v.id = v.positionId;
                    if(v.children != undefined){
                        this.recursivePosition(v.children);
                    }
                    return v
                })
                this.positionList = data;
            },
          
           
           
            handleSelectionChange(data){
                let tagIds = [];
                data.forEach(function (obj) {
                    tagIds.push(obj.tagId);
                });
                this.multipleSelection = tagIds;
            },
            handleSave(){
                this.form.selectMonth=this.listQuery.selectMonth;
                this.form.projectId=this.listQuery.projectId;
              
               alert("month=="+this.form.selectMonth);
               alert("projectId=="+this.form.projectId);
               alert("positionId=="+listQuery.positionId);
               alert("positionId=="+listQuery.positionId);
            },
            // 设置日期范围查询条件
            setDateRange(dateRange) {
                if (dateRange) {
                    this.listQuery.startTime = dateRange[0].getTime();
                    this.listQuery.endTime = dateRange[1].getTime();
                } else {// 清空
                    this.listQuery.startTime = null;
                    this.listQuery.endTime = null;
                }
            },
             //-----查询
            
              handleFilter() {
                this.listQuery.current = 1;
                
                this.getTagPage();
            },
           
            //------------------
              getTagPage() {
                this.listLoading = true;
                 // alert("month=="+this.listQuery.selectMonth);
                 // alert("position=="+this.listQuery.positionId);
      
                getTagList(this.listQuery).then(response => {
                    response.rows.map(v =>{
                        v.edit = false;
                    })
                    this.list = response.rows;
                    this.total = response.total;
                    this.listLoading = false;
                })
            },
             getTagTypeList(){
                getTagTypeList({classifyCode: 'tag_type'}).then((row)=> {
                    this.tagTypeList = row;
                })
            },
               editTag(row) {
                this.setTag(row);
                row.edit = true;
            },
            cancelTagEdit(row) {
                this.resetTag(row);
                row.edit = false;
            },
                setTag(row) {
                row.ordTagType = row.tagType;
                row.ordTagName = row.tagName;
            },
             resetTag(row) {
                row.tagType = row.ordTagType;
                row.tagName = row.ordTagName;
            },
            updateTag(row) {
                this.listLoading = true;
                this.form.selectMonth=this.listQuery.selectMonth;
                this.form.projectId=this.listQuery.projectId;
                this.form.positionId=this.listQuery.positionId;
               alert("month=="+this.form.selectMonth);
               alert("projectId=="+this.form.projectId);
               alert("positionId=="+this.form.positionId);
          

                updateTag(row).then(() => {
                    this.$message({type: 'success', message: this.$t('message.operationSuccess')});
                    row.edit = false;
                    this.listLoading = false;
                    this.setTag(row);
                }).catch(() => {
                    this.listLoading = false;
                })
            },
        }
    }
</script>
